import Commons from '../../../Services/Common/Common';

export const M_EMT_BASIC_01_Schema = {
  mapper: {
    /** 비상연락망 조회 GetEmTelR1 (관리 — 사업장 부서별) */
    search1: {
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
      DepCd: (context) => Commons.EncryptAES(context.depCd ?? '') || '',
      UserId: (context) => context.userInfo?.userid,
    },
    /** 부서 목록 조회 getDepLast */
    search2: {
      CustCd: (context) =>
        Commons.EncryptAES(
          context.userInfo?.custCd ?? context.search?.custCd ?? ''
        ) || '',
      SearchText: () => Commons.EncryptAES('') || '',
    },
    /** 인원 선택 GetPerCustomR4 */
    search3: {
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
      UserId: (context) => context.userInfo?.userid,
    },
    /** SaveEmTelU1 Query — UserId, CustCd, DepCd(등록 대상 부서, 암호화) */
    save1: {
      UserId: (context) => context.userInfo?.userid,
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? context.custCd ?? '') ||
        '',
      DepCd: (context) => Commons.EncryptAES(context.depCd ?? '') || '',
    },
    /** SaveEmTelU1 Body item — targetUserId, emergencyTelYn, resumeApprovalYn(암호화) */
    save1BodyItem: {
      targetUserId: (context) => {
        const memberId =
          context.targetUserId ??
          context.TargetUserId ??
          context.manageId ??
          context.ManageId ??
          context.id ??
          context.userId ??
          context.userid ??
          '';
        return memberId ? Commons.EncryptAES(String(memberId)) : '';
      },
      emergencyTelYn: (context) =>
        Commons.EncryptAES(
          context.emergencyTelYn ?? context.EmergencyTelYn ?? 'Y'
        ) || '',
      resumeApprovalYn: (context) =>
        Commons.EncryptAES(
          context.resumeApprovalYn ?? context.ResumeApprovalYn ?? 'Y'
        ) || '',
    },
  },
};
